import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormEmpresa from "./formEmpresa";

export function EmpresaEditar() {
  const idempresa = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo="Editar Empresa" />
        <FormEmpresa idempresa={idempresa.id} acao="Editar" />
      </div>
    </>
  );
}
